import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68407d16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "createTime" }
const _hoisted_4 = { class: "box mark" }
const _hoisted_5 = { style: {"color":"red","padding":"12px","background":"rgb(229, 246, 244)","font-weight":"600"} }
const _hoisted_6 = { class: "high-light" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "产品销售排行 TOP 5", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "产品名称", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "下单成功量", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "percentage" }, "下单成功率", -1))
const _hoisted_12 = [
  _hoisted_9,
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "mark" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "分销商销售排行 TOP 5", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "分销商", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "下单成功量", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "percentage" }, "下单成功率", -1))
const _hoisted_19 = [
  _hoisted_16,
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = { class: "mark" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "percentage" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "产品销售排行 TOP 5", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "产品名称", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "激活成功量", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "percentage" }, "激活成功率", -1))
const _hoisted_27 = [
  _hoisted_24,
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = { class: "mark" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "分销商销售排行 TOP 5", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "分销商", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "激活成功量", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "percentage" }, "激活成功率", -1))
const _hoisted_34 = [
  _hoisted_31,
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = { class: "mark" }
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "percentage" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "运营商销售排行榜", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "运营商名称", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "本月激活成功量", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "percentage" }, "本月激活成功率", -1))
const _hoisted_42 = [
  _hoisted_39,
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = { class: "mark" }
const _hoisted_44 = { class: "row" }
const _hoisted_45 = { class: "percentage" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "分销商销售排行", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "分销商", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "本月激活成功量", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "percentage" }, "本月激活成功率", -1))
const _hoisted_50 = [
  _hoisted_47,
  _hoisted_48,
  _hoisted_49
]
const _hoisted_51 = { class: "mark" }
const _hoisted_52 = { class: "row" }
const _hoisted_53 = { class: "percentage" }

import { ref, watch, onMounted, nextTick } from "vue";
import { useRoute } from "vue-router";
import { CellGroup, Cell, Tabs, Tab, Overlay, Loading, Empty } from "vant";
import { formatPercentage, numToMoney } from "@/utils";
import createWatermark from "@/utils/watermark";
import dayjs from "dayjs";

import request from "@/provide/fetch";


export default /*#__PURE__*/_defineComponent({
  __name: 'ECommerce',
  setup(__props) {

const route = useRoute();
const active = ref(0);
const field = ref("orderPayCount");
const productOrderPayCountAsc = ref(false); // 产品-下单成功量升序
// const orderPayRateAsc = ref(false); // 下单成功率升序
const distributorOrderPayCountAsc = ref(false); // 分销商-下单成功量升序

const visible = ref(false);
const pageData = ref<any>({});
const getPageData = async () => {
  const res = await request({
    url: "/api/wx/ele/total",
    method: "POST",
    data: {
      startDay: route?.params.time,
      endDay: route?.params.time,
      groupUnit: sessionStorage.getItem("openid"),
    },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    pageData.value = res.data;
    visible.value = true;
    console.log(pageData.value);
  } else {
    // showFailToast(res.data);
  }
};
getPageData();

// 产品排行
const productsList = ref<any>([]);
const getProductsData = async () => {
  const res = await request({
    url: "/api/wx/ele/product-detail",
    method: "POST",
    data: {
      pageParam: {
        current: 1,
        size: 5,
      },
      searchOption: {
        startDay: route?.params.time,
        endDay: route?.params.time,
        orderItem: {
          field: field.value,
          asc: productOrderPayCountAsc.value,
        },
        groupUnit: sessionStorage.getItem("openid"),
      },
    },
    // params: {
    //   openId: 'o7Gwj6b4bHVGwrEVKckufk8jjIh4',
    // },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    productsList.value = res.data.records;
  } else {
    // showFailToast(res.data);
  }
};
getProductsData();

// 分销商排行
const distributorLoading = ref(false);
const distributorList = ref<any>([]);
const getDistributorList = async () => {
  distributorLoading.value = true;
  const res = await request({
    url: "/api/wx/ele/distributor-detail",
    method: "POST",
    data: {
      pageParam: {
        current: 1,
        size: 5,
      },
      searchOption: {
        startDay: route?.params.time,
        endDay: route?.params.time,
        orderItem: {
          field: field.value,
          asc: distributorOrderPayCountAsc.value,
        },
        groupUnit: sessionStorage.getItem("openid"),
      },
    },
    // params: {
    //   openId: 'o7Gwj6b4bHVGwrEVKckufk8jjIh4',
    // },
  });
  distributorLoading.value = false;
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    distributorList.value = res.data.records;
  } else {
    // showFailToast(res.data);
  }
};

const getDistributorActiveList = async () => {
  distributorLoading.value = true;
  let startTime = dayjs(route?.params.time).format("YYYYMM") + "01";
  const res = await request({
    url: "/api/wx/ele/distributor-detail",
    method: "POST",
    data: {
      pageParam: {
        current: 1,
        size: 1000,
      },
      searchOption: {
        startDay: startTime,
        endDay: route?.params.time,
        orderItem: {
          field: field.value,
          asc: distributorOrderPayCountAsc.value,
        },
        groupUnit: sessionStorage.getItem("openid"),
      },
    },
    // params: {
    //   openId: 'o7Gwj6b4bHVGwrEVKckufk8jjIh4',
    // },
  });
  distributorLoading.value = false;
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    distributorList.value = res.data.records;
  } else {
    // showFailToast(res.data);
  }
};

getDistributorList();
const operatorList = ref<any>([]);
const getoperatorList = async () => {
  distributorLoading.value = true;
  const res = await request({
    url: "/api/wx/ele/operator-detail",
    method: "POST",
    data: {
      pageParam: {
        current: 1,
        size: 5,
      },
      searchOption: {
        startDay: dayjs(route?.params.time).format("YYYYMM") + "01",
        endDay: route?.params.time,
        orderItem: {
          field: field.value,
          asc: distributorOrderPayCountAsc.value,
        },
        groupUnit: sessionStorage.getItem("openid"),
      },
    },
    // params: {
    //   openId: 'o7Gwj6b4bHVGwrEVKckufk8jjIh4',
    // },
  });
  distributorLoading.value = false;
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    operatorList.value = res.data.filter((item) => item.activeCount > 0);
  } else {
    // showFailToast(res.data);
  }
};
watch(productOrderPayCountAsc, () => {
  getProductsData();
});
watch(distributorOrderPayCountAsc, () => {
  getDistributorList();
});

const handleChange = (name: number) => {
  if (name === 2) {
    field.value = "activeCount";
    getoperatorList();
    getDistributorActiveList();
  } else if (name === 1) {
    field.value = "activeCount";
    getProductsData();
    getDistributorList();
  } else {
    field.value = "orderPayCount";
    getProductsData();
    getDistributorList();
  }
};

const getUserInfo = async () => {
  return request({
    url: "/api/wx/user/getUserByOpenId",
    method: "GET",
    params: {
      openId: sessionStorage.getItem("openid"),
    },
  }).then((res) => {
    if (res.code === 200) {
      sessionStorage.setItem("name", res.data.name);
    }
  });
};
onMounted(() => {
  if (sessionStorage.getItem("name")) {
    createWatermark(sessionStorage.getItem("name"), "mark", "#fff");
  } else {
    getUserInfo().then(() => {
      createWatermark(sessionStorage.getItem("name"), "mark", "#fff");
    });
  }
});

const tabs = ref();
watch(visible, () => {
  nextTick(() => {
    tabs.value.resize();
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, "生成时间： " + _toDisplayString(_unref(dayjs)(Object.values(pageData.value)[0]?.time).format("YYYY-MM-DD")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageData.value, (item, key, index) => {
          return (_openBlock(), _createBlock(_unref(CellGroup), { key: index }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_5, " ·" + _toDisplayString(key), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.baseValueDataList, (childRenItem, childRenIndex) => {
                return (_openBlock(), _createBlock(_unref(Cell), {
                  title: childRenItem.name,
                  size: "large",
                  class: "bold",
                  "title-style": { width: '120px', flex: 'inherit' },
                  key: childRenIndex
                }, {
                  value: _withCtx(() => [
                    _createElementVNode("span", _hoisted_6, [
                      _createTextVNode(_toDisplayString(childRenItem.type === "percentage"
                    ? _unref(formatPercentage)(childRenItem.value)
                    : _unref(numToMoney)(childRenItem.value)) + "（环比：", 1),
                      _createElementVNode("span", {
                        style: _normalizeStyle({
                    color: childRenItem.percentage >= 0 ? 'red' : 'green',
                  })
                      }, _toDisplayString(`${
                      childRenItem.percentage >= 0 ? "+" : ""
                    }${_unref(formatPercentage)(childRenItem.percentage)}`), 5),
                      _createTextVNode("） ")
                    ])
                  ]),
                  _: 2
                }, 1032, ["title"]))
              }), 128))
            ]),
            _: 2
          }, 1024))
        }), 128)),
        _hoisted_7,
        _createVNode(_unref(Tabs), {
          active: active.value,
          "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event)),
          onChange: handleChange,
          ref_key: "tabs",
          ref: tabs
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Tab), { title: "下单成功纬度" }, {
              default: _withCtx(() => [
                _hoisted_8,
                _createElementVNode("div", {
                  class: "row",
                  style: _normalizeStyle({
                background: '#E5F6F4',
                fontWeight: 500,
                padding: '0 0.32rem',
              })
                }, _hoisted_12, 4),
                (!productsList.value.length)
                  ? (_openBlock(), _createBlock(_unref(Empty), {
                      key: 0,
                      description: "暂无数据",
                      "image-size": "100"
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productsList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "border-b",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", null, _toDisplayString(item.productName), 1),
                        _createElementVNode("div", null, _toDisplayString(_unref(numToMoney)(item.orderPayCount)), 1),
                        _createElementVNode("div", null, _toDisplayString(item.orderPayRate), 1)
                      ])
                    ]))
                  }), 128))
                ]),
                _hoisted_15,
                _createElementVNode("div", {
                  class: "row",
                  style: _normalizeStyle({
                background: '#E5F6F4',
                fontWeight: 500,
                padding: '0 0.32rem',
              })
                }, _hoisted_19, 4),
                (!distributorList.value.length)
                  ? (_openBlock(), _createBlock(_unref(Empty), {
                      key: 1,
                      description: "暂无数据",
                      "image-size": "100"
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(distributorList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "border-b",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", null, _toDisplayString(item.distributor), 1),
                        _createElementVNode("div", null, _toDisplayString(_unref(numToMoney)(item.orderPayCount)), 1),
                        _createElementVNode("div", _hoisted_22, _toDisplayString(item.orderPayRate), 1)
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(Tab), { title: "当天激活成功纬度" }, {
              default: _withCtx(() => [
                _hoisted_23,
                _createElementVNode("div", {
                  class: "row",
                  style: _normalizeStyle({
                background: '#E5F6F4',
                fontWeight: 500,
                padding: '0 0.32rem',
              })
                }, _hoisted_27, 4),
                (!productsList.value.length)
                  ? (_openBlock(), _createBlock(_unref(Empty), {
                      key: 0,
                      description: "暂无数据",
                      "image-size": "100"
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_28, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productsList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "border-b",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", null, _toDisplayString(item.productName), 1),
                        _createElementVNode("div", null, _toDisplayString(_unref(numToMoney)(item.activeCount)), 1),
                        _createElementVNode("div", null, _toDisplayString(item.activeRate), 1)
                      ])
                    ]))
                  }), 128))
                ]),
                _hoisted_30,
                _createElementVNode("div", {
                  class: "row",
                  style: _normalizeStyle({
                background: '#E5F6F4',
                fontWeight: 500,
                padding: '0 0.32rem',
              })
                }, _hoisted_34, 4),
                (!distributorList.value.length)
                  ? (_openBlock(), _createBlock(_unref(Empty), {
                      key: 1,
                      description: "暂无数据",
                      "image-size": "100"
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_35, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(distributorList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "border-b",
                      style: _normalizeStyle({ padding: '0 0.32rem' }),
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", null, _toDisplayString(item.distributor), 1),
                        _createElementVNode("div", null, _toDisplayString(_unref(numToMoney)(item.activeCount)), 1),
                        _createElementVNode("div", _hoisted_37, _toDisplayString(item.activeRate), 1)
                      ])
                    ], 4))
                  }), 128))
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(Tab), { title: "本月激活成功维度" }, {
              default: _withCtx(() => [
                _hoisted_38,
                _createElementVNode("div", {
                  class: "row",
                  style: _normalizeStyle({
                background: '#E5F6F4',
                fontWeight: 500,
                padding: '0 0.32rem',
              })
                }, _hoisted_42, 4),
                (!operatorList.value.length)
                  ? (_openBlock(), _createBlock(_unref(Empty), {
                      key: 0,
                      description: "暂无数据",
                      "image-size": "100"
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_43, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(operatorList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "border-b",
                      style: _normalizeStyle({ padding: '0 0.32rem' }),
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("div", null, _toDisplayString(item.operator), 1),
                        _createElementVNode("div", null, _toDisplayString(item.activeCount), 1),
                        _createElementVNode("div", _hoisted_45, _toDisplayString(item.activeRate), 1)
                      ])
                    ], 4))
                  }), 128))
                ]),
                _hoisted_46,
                _createElementVNode("div", {
                  class: "row",
                  style: _normalizeStyle({
                background: '#E5F6F4',
                fontWeight: 500,
                padding: '0 0.32rem',
              })
                }, _hoisted_50, 4),
                (!distributorList.value.length)
                  ? (_openBlock(), _createBlock(_unref(Empty), {
                      key: 1,
                      description: "暂无数据",
                      "image-size": "100"
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_51, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(distributorList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "border-b",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("div", null, _toDisplayString(item.distributor), 1),
                        _createElementVNode("div", null, _toDisplayString(_unref(numToMoney)(item.activeCount)), 1),
                        _createElementVNode("div", _hoisted_53, _toDisplayString(item.activeRate), 1)
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["active"])
      ])
    ], 512), [
      [_vShow, visible.value]
    ]),
    _createVNode(_unref(Overlay), {
      class: "overlay",
      show: !visible.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Loading), { type: "spinner" })
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})